import { render, staticRenderFns } from "./MediaOwnerScreenTagSelectGeneric.vue?vue&type=template&id=2dced934&"
import script from "./MediaOwnerScreenTagSelectGeneric.vue?vue&type=script&lang=js&"
export * from "./MediaOwnerScreenTagSelectGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports